import type {
  Site,
  SiteCreateInput,
  SiteStatus,
  SiteUpdateInput,
} from "@chat-yai/shared/admin-types";
import { request } from "@/api/client";

export const sitesApi = {
  list(query: { status?: SiteStatus } = {}) {
    return request<{ sites: Site[] }>("/admin/sites", { query });
  },
  create(input: SiteCreateInput) {
    return request<{ site: Site }>("/admin/sites", {
      method: "POST",
      body: input,
    });
  },
  update(id: string, input: SiteUpdateInput) {
    return request<{ site: Site }>(`/admin/sites/${id}`, {
      method: "PATCH",
      body: input,
    });
  },
  remove(id: string) {
    return request<{ ok: true }>(`/admin/sites/${id}`, { method: "DELETE" });
  },
};
